<template>
<div v-if="loaded">
<!-- {{cleanData[0].data.length}} -->
  <!-- <div v-if="cleanData[0].data.length != 0"> -->
    <!-- {{ labels }}
    {{ cleanData }}

    {{ dataset[0].answers.length }}
     -->
    <RadarChart v-if="loaded" :labels="labels" :dataset="cleanData" />
  <!-- </div> -->
  </div>
</template>


<script>
import RadarChart from "./RadarChart.vue";

export default {
  components: { RadarChart },
  props: {
    dataset: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      loaded:false,
      labels: [
        "Hälsa",
        "Kunskapsinhämtning",
        "Måluppfyllelse",
        "Närvaro",
        "Koncentration och impulskontroll",
        "Socialt",
      ],
      values: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
      ],
      cleanData: [
        {
          label: "Alla",
          backgroundColor: "rgba(179,181,198,0.2)",
          borderColor: "rgba(179,181,198,1)",
          pointBackgroundColor: "rgba(179,181,198,1)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgba(179,181,198,1)",
          data: [],
          // data: [2, 4, -2,0,-4, 2]
        },
      ],
    };
  },
  methods: {
    AddValue(data, place) {
      //   (  this.values[place][0])
      if (data == "1") {
        this.values[place][0] = this.values[place][0] += 1;
      } else if (data == "0") {
        this.values[place][1] = this.values[place][1] += 1;
      }
    },
    async StartUp(){

this.dataset.forEach((data) => {
      //
      for (let i = 2; i < data.answers.length - 1; i++) {
        let element = data.answers[i];
        if (
          // i == 0 || i == 1||
         i == 18|| i == 19|| i == 21|| i == 22) {
          //Hälsa
          this.AddValue(element, 0);
        } else if (
          (i == 2) | (i == 3) ||
          i == 4 ||
          i == 5 ||
          i == 8 ||
           i == 15 ||
          i == 16
        ) {
          //Kunskapsinhämtning
          this.AddValue(element, 1);
        }else if (i == 20) {
          //Närvaro
          this.AddValue(element, 3);
        } else if (i == 6 ||i == 7 || i == 9 || i == 10 || i == 11) {
          //koncentration och impulskontroll
          this.AddValue(element, 4);
        } else if (i == 13 ||i == 14 ) {
          //Socialt
          this.AddValue(element, 5);
        }
        //  (data.answers[i])

        if (i == 2 || i == 12 || i == 16 ) {
          //Måluppfyllelse
          //  ("Mål! " + element);
          if (i == 12 || i == 16) {
            if (element != 1) {
              if (element == 3) {
                element = 1;
              }
              this.AddValue(element, 2);
            }
          } else {
            this.AddValue(element, 2);
          }
        } 


      }
    });
    let output = [];
    this.values.forEach((data) => {
      output.push(data[0] - data[1]);
    });
    let SUBS = [4, 7, 1, 5, 2, 3];
    for (let i = 0; i < SUBS.length; i++) {
      const element = SUBS[i];
      output[i] = Math.round(output[i] / element);
    }
// this.cleanData=output

    this.cleanData = [
      {
        label: "Alla",
        backgroundColor: "rgba(179,181,198,0.2)",
        // borderColor: "rgba(179,181,198,1)",
        borderColor: "#90CAF9",
        pointBackgroundColor: "#EF5350",
        // pointBackgroundColor: "rgba(179,181,198,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(179,181,198,1)",
        data: output,
        // borderColor: ["#A5D6A7", "#EF5350", "#90CAF9", "blue", "red", "blue"],
      },
    ];
    this.loaded=true;
      
    },

  },
  // mounted()  {
    
    created () {
      
    this.StartUp()
  },
};
</script>
